<template>
  <VAppLayout :showHelp="showHelp"
              :is-nav-visible="false"
              @closeHelp="closeHelp">
    <div class="welcome-page-title-wrap"
         :style="cssVars">
      <VAppLocale class="welcome-page-locale" />
      <div class="welcome-page-title">
        <img :src="logoUrl"
             alt="Logo"
             v-if="showLogoInsteadOfName"
             class="main-menu-logo">
        <h1 v-else>{{ comCompanyName }}</h1>
      </div>
    </div>


    <div class="welcome-page-content">
      <ul class="welcome-page-content-ul">
        <li v-for="(navItem, index) in comActiveNavItems"
            :key="index">
          <router-link :to="'/' + navItem[0]"
                       class="welcome-page-button">
            <span>{{ $t(`nav.${navItem[0]}.title`) }}</span>
            <IconArrowDown />
          </router-link>
        </li>
        <li v-for="(navItem, index) in comCustomItems"
            :key="index + navItem.title">
          <a :href="navItem.url"
             class="welcome-page-button">
            <span>{{ navItem.title }}</span>
            <IconArrowDown />
          </a>
        </li>
      </ul>
    </div>
  </VAppLayout>
</template>

<script>
import VAppLayout from "@/layouts/VAppLayout.vue";
import VAppLocale from "@/components/ui/VAppLocale.vue";
import IconArrowDown from "./icons/IconArrowDown.vue";

export default {
  name: 'Welcome',
  components: {
    VAppLocale,
    VAppLayout,
    IconArrowDown,
  },
  data() {
    return {
      isLocalisationHiddenListVisible: false,
      showHelp: false,
    };
  },
  computed: {
    comCompanyLogo() {
      return this.$store.getters['getCompanyData'].locale.logo;
    },
    comCompanyName() {
      return this.$store.getters['getCompanyData'].locale.name;
    },
    cssVars() {
      return {
        '--bg-image': `url(${this.$store.getters['getCompanyData'].locale.photo})`,
      };
    },
    comActiveNavItems() {
      let navItems = this.$store.getters['getCompanyData'].locale.nav_items;

      if (this.$store.getters['getTableNum'] === null && !this.$store.getters['getCartEnabled']) {
        navItems = (Object.entries(navItems)).filter(item => item[0] !== 'bill');

        return (navItems).filter(item => item[1]);
      }
      return Object.entries(navItems).filter(item => item[1]);
    },
    comCustomItems() {
      let navItems = this.$store.getters['getCompanyData'].locale.nav_items_custom;

      return navItems;
    },
    logoUrl() {
      return this.$store.getters['getCompanyData'].locale.logo || '/assets/logo.png';
    },
    showLogoInsteadOfName() {
      return this.$store.getters['getCompanyData'].locale.sm_show_logo_instead_of_name || false;
    }
  },
  methods: {
    enableHelp() {
      this.showHelp = true;
    },
    closeHelp() {
      this.showHelp = false;
    },
  }
};
</script>

<style lang="scss" scoped>
@import "/src/scss/assets/variables";

ul {
  margin: 0;
  padding: 0;
  list-style: none;
}

.v-container {
  height: auto;
}

h1 {
  margin: 0;
  padding: 0;

  text-align: center;

  font: {
    weight: 700;
    size: 32px;
  }
}

.welcome-page-title-wrap {
  position: relative;

  height: 275px;

  border-radius: 0 0 20px 20px;

  background:
    linear-gradient(180.1deg, rgba(11, 11, 26, 0.05) 0.09%, rgba(4, 15, 33, 0) 40.33%, rgba(17, 8, 19, 0.5) 99.91%),
    var(--bg-image);

  background: {
    size: cover;
    repeat: no-repeat;
    position: center;
  }

  .welcome-page-locale {
    position: absolute;
    top: 22px;
    right: 22px;

    border-radius: 6px;
    box-shadow: 0px 1px 10px 0px #0000001A;

    background-color: white;
  }

  .welcome-page-title {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;

    height: 100%;

    h1 {
      margin-bottom: 60px;
      color: white;
    }
  }
}

.main-menu-logo {
  max-width: 300px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.welcome-page-content {
  padding: 32px 22px;

  &-ul {
    display: grid;
    gap: 12px;
  }

  .welcome-page-button {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 62px;

    padding: 22px;

    border-radius: 10px;

    background-color: #F3F3FF;

    span {
      font-weight: 500;
      font-size: 20px;
      line-height: 100%;

      color: black;
    }

    svg {
      transform: rotate(-90deg);
    }
  }
}

// .welcome-page {
//   display: flex;
//   flex-direction: column;
//   height: 100%;

//   &-title {
//     display: flex;
//     align-items: center;
//     justify-content: space-between;
//     height: 86px;
//     flex-shrink: 0;


//   }

//   &-content {
//     display: flex;
//     flex-direction: column;
//     gap: 33px;
//     flex: 1 1;
//     position: relative;
//     z-index: 2;
//     padding: 0 7px;

//     &_title {
//       display: flex;
//       justify-content: center;
//       align-items: center;
//       border-radius: 16px;
//       height: 200px;

//       .logo {
//         max-height: 96px;
//         max-width: 150px;
//       }
//     }

//     &::v-deep .nav {
//       flex: 1 1;
//       background-color: rgba(0, 0, 0, 0);

//       .welcome-info {
//         display: block;
//         width: 100%;
//         text-align: center;
//         color: white;
//         font-size: 20px;
//         font-weight: 590;
//         line-height: 23.87px;
//         padding: 25px;
//       }

//       ul {
//         display: flex;
//         flex-direction: column;
//         gap: 16px;
//         flex: 1 1;
//         padding: 0 9px;

//         li {
//           width: 100%;
//           flex: 1 1;

//           &.menu-info {
//             display: none;
//           }

//           a {
//             font-size: 24px;
//             width: 100%;
//             justify-content: space-between;
//             flex-direction: row-reverse;
//             align-items: center;
//             border-radius: 12px;
//             height: 100%;
//             padding: 12px 24px;
//             background-color: $color_white_titan;

//             p {
//               margin: 0;
//               display: flex;
//               flex-direction: column;
//               gap: 5px;

//               font: {
//                 weight: 700;
//               }

//               ;
//               color: $color_black;

//               &.badge {
//                 display: none;
//               }

//               span {
//                 display: flex;
//                 color: $color_grey_dusty;

//                 font: {
//                   size: 14px;
//                 }

//                 ;
//                 letter-spacing: 1px;
//               }
//             }

//             svg {
//               &:is(.nav_icon) {
//                 display: none;
//               }

//               &:is(.nav_arrow) {
//                 display: flex;
//               }
//             }
//           }
//         }
//       }
//     }
//   }

//   &::after {
//     position: absolute;
//     content: "";
//     z-index: 1;
//     left: 0;
//     bottom: 0;
//     top: 158px;
//     right: 0;
//     border-radius: 40px 40px 0 0;
//     background-color: $color_purple;
//   }
// }</style>
